const dashboard = 'dashboard';
const login = 'login';
const error = 'error';
const register = 'register';
const userDetails = 'user_details';
const organization = 'organization';
const roles = 'roles';
const permissions = 'permissions';
const incentiveProgram = 'incentive_program';
const attribute = 'user_attr_master_mapping';
const profile = 'profile';
const bulkUser = 'get_user_bulk_upload_data';
const communicationHub = 'communication_hub';
const nudgeConfiguration = 'nudge_configuration';
const templateDetails = 'template_details';
const audienceGrouping = 'audience_group';

const resourceName = {
  dashboard,
  login,
  error,
  register,
  userDetails,
  organization,
  roles,
  incentiveProgram,
  attribute,
  permissions,
  profile,
  bulkUser,
  communicationHub,
  nudgeConfiguration,
  templateDetails,
  audienceGrouping,
};

export default resourceName;
